import * as content from './content/actions';
import * as environment from './environment/actions';
import * as intl from './intl/actions';
import * as location from './location/actions';
import * as page from './page/actions';
import * as responsive from './responsive/actions';
import * as session from './session/actions';
import * as theme from './theme/actions';
import * as toasts from './toasts/actions';
import * as widgets from './widgets/actions';

export default {
  ...content,
  ...environment,
  ...intl,
  ...location,
  ...page,
  ...responsive,
  ...session,
  ...theme,
  ...toasts,
  ...widgets,
};
